import React from 'react';
import {
    CurrencySelectionPage,
    ReceiveCurrencySelectionPage,
    SendCurrencySelectionPage,
    TradeCurrencySelectionPage,
} from '~/processes/dashboard';
import {
    selectCryptoOptionsView,
    selectFiatTopupOptionsView,
    selectReceiveOptionsView,
    selectSendOptionsView,
    selectTradeOptions,
} from '~/redux/finances';
import {createAvailabilityBasedGate} from '~/root/route-utils/AppGates';
import {RouteRegistrar} from '~/root/route-utils/defineRoutes';

export default function registerRoutes(route: RouteRegistrar) {
    route.with({Gate: createAvailabilityBasedGate(selectSendOptionsView)})('/select-currency-to/send', () => (
        <SendCurrencySelectionPage selectOperations={selectSendOptionsView} title={'Send'} verb={'send'} />
    ));
    route.with({Gate: createAvailabilityBasedGate(selectReceiveOptionsView)})('/select-currency-to/receive', () => (
        <ReceiveCurrencySelectionPage selectOperations={selectReceiveOptionsView} title={'Receive'} verb={'receive'} />
    ));

    route.with({Gate: createAvailabilityBasedGate(selectTradeOptions)})('/select-currency-to/exchange', () => (
        <TradeCurrencySelectionPage selectOperations={selectTradeOptions} title={'Trade'} verb={'trade'} />
    ));
    route.with({Gate: createAvailabilityBasedGate(selectFiatTopupOptionsView)})(
        '/select-currency-to/topup-fiat',
        () => <CurrencySelectionPage selectOperations={selectFiatTopupOptionsView} title={'Top up'} verb={'top up'} />
    );
    route.with({Gate: createAvailabilityBasedGate(selectCryptoOptionsView)})('/select-currency-to/buy-crypto', () => (
        <CurrencySelectionPage selectOperations={selectCryptoOptionsView} title={'Crypto'} verb={'buy'} />
    ));
}
